import request from '@/utils/request'
import Vue from 'vue'
import signMd5Utils from '@/utils/encryption/signMd5Utils'


//post
export function postActionManage(service,url, parameter) {
    let sign = signMd5Utils.getSign(url, parameter);
    //将签名和时间戳，添加在请求接口 Header
    let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToString() };

    return request({
        url: service + url,
        method: 'post',
        data: parameter,
        headers: signHeader
    })
}

//post method= {post | put}
export function httpActionManage(service,url, parameter, method) {
    let sign = signMd5Utils.getSign(url, parameter);
    //将签名和时间戳，添加在请求接口 Header
    let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToString() };

    return request({
        url: service + url,
        method: method,
        data: parameter,
        headers: signHeader,
        timeout: 30000
    })
}

//put
export function putActionManage(service,url, parameter) {
    return request({
        url: service + url,
        method: 'put',
        data: parameter
    })
}

//get
export function getActionManage(service,url, parameter) {
    let sign = signMd5Utils.getSign(url, parameter);
    //将签名和时间戳，添加在请求接口 Header
    let signHeader = { "X-Sign": sign, "X-TIMESTAMP": signMd5Utils.getDateTimeToString() };

    return request({
        url: service + url,
        method: 'get',
        params: {
            _t: Date.parse(new Date()) / 1000,
            ...parameter
        },
        headers: signHeader
    })
}

//deleteAction
export function deleteActionManage(service,url, parameter) {
    return request({
        url: service + url,
        method: 'delete',
        params: parameter
    });
}

//字典标签专用（通过code获取字典数组）
export const ajaxGetDictItemsManage = (service,url, params) => getActionManage(service,url, params);

